import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Why Us',   href: '#why' },
  { label: 'Sectors',  href: '#sectors' },
  { label: 'Process',  href: '#process' },
];

export default function Navbar() {
  const [scrolled,     setScrolled]     = useState(false);
  const [menuOpen,     setMenuOpen]     = useState(false);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const ids = ['services','why','sectors','process','contact'];
      let current = '';
      ids.forEach(id => {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 120) current = id;
      });
      setActiveSection(current);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: scrolled ? 'rgba(11,22,40,0.97)' : 'rgba(11,22,40,0.85)',
        backdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(0,180,216,0.12)',
        padding: '0 5%',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: '70px',
        transition: 'background 0.3s',
      }}>
        {/* Logo */}
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.35rem', fontWeight: 700, color: 'var(--white)', letterSpacing: '-0.5px' }}>
          ADEL<span style={{ color: 'var(--electric)' }}>ZONE</span> <span style={{ fontWeight: 400, fontSize: '0.9rem', color: 'var(--slate)' }}>LTD</span>
        </div>

        {/* Desktop Links */}
        <ul style={{ display: 'flex', gap: '2rem', listStyle: 'none', alignItems: 'center' }}
            className="desktop-nav">
          {navLinks.map(l => (
            <li key={l.label}>
              <button
                onClick={() => handleNav(l.href)}
                style={{
                  background: 'none', border: 'none',
                  color: activeSection === l.href.slice(1) ? 'var(--electric)' : 'var(--slate-light)',
                  fontSize: '0.88rem', fontWeight: 500, letterSpacing: '0.3px',
                  cursor: 'pointer', transition: 'color 0.2s',
                }}>
                {l.label}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => handleNav('#contact')}
              style={{
                background: 'var(--electric)', color: 'var(--navy)',
                padding: '0.45rem 1.3rem', borderRadius: '6px',
                fontWeight: 700, fontSize: '0.83rem', letterSpacing: '0.4px',
                transition: 'background 0.2s',
              }}
              onMouseEnter={e => e.target.style.background='var(--electric-hi)'}
              onMouseLeave={e => e.target.style.background='var(--electric)'}>
              Get in Touch
            </button>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMenuOpen(o => !o)}
          style={{ background: 'none', border: 'none', color: 'var(--white)', display: 'none' }}
          className="mobile-menu-btn">
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{
          position: 'fixed', top: '70px', left: 0, right: 0, zIndex: 99,
          background: 'var(--navy-mid)',
          borderBottom: '1px solid rgba(0,180,216,0.15)',
          padding: '1.5rem 5%',
          display: 'flex', flexDirection: 'column', gap: '1rem',
        }}>
          {navLinks.map(l => (
            <button key={l.label}
              onClick={() => handleNav(l.href)}
              style={{
                background: 'none', border: 'none', textAlign: 'left',
                color: 'var(--slate-light)', fontSize: '1rem',
                fontWeight: 500, padding: '0.4rem 0',
              }}>
              {l.label}
            </button>
          ))}
          <button
            onClick={() => handleNav('#contact')}
            style={{
              background: 'var(--electric)', color: 'var(--navy)',
              padding: '0.7rem 1.5rem', borderRadius: '8px',
              fontWeight: 700, fontSize: '0.9rem', marginTop: '0.5rem',
            }}>
            Get in Touch
          </button>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </>
  );
}
